import React, { useState, useEffect } from "react";
import { Modal, Form, Input, Select, Checkbox } from "antd";
import callApi from "../../constants/API/CallApi";
import "react-phone-input-2/lib/style.css";
import { ShowToast, Severty } from "../../helper/toast";
import { addKyu, ListBelt } from "../../constants/API/API";

const KyuAdd = ({ visible, setVisible, refresh }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [belts, setBelts] = useState([]);
  const [beltPage, setBeltPage] = useState(1);
  const [hasMoreBelts, setHasMoreBelts] = useState(true);
  const [loadingBelts, setLoadingBelts] = useState(false);

  const triggersGraduationEligibility = Form.useWatch(
    "triggersGraduationEligibility",
    form
  );

  useEffect(() => {
    if (triggersGraduationEligibility) {
      form.setFieldsValue({ requiredClasses: 0 });
    }
  }, [triggersGraduationEligibility]);

  const loadBelts = async (page = 1) => {
    setLoadingBelts(true);
    await callApi({
      callback: () => ListBelt({ page, limit: 1000 }),
      onSuccess: ({ data: { list = [], paging = {} } = {} } = {}) => {
        setBelts((prev) => (page === 1 ? list : [...prev, ...list]));
        setBeltPage(page);
        setHasMoreBelts(Boolean(paging.hasNextPage));
      },
      onError: (err) => {
        ShowToast(err, Severty.ERROR);
      },
    });
    setLoadingBelts(false);
  };

  useEffect(() => {
    loadBelts(1);
  }, [refresh]);

  const handleBeltPopupScroll = async (event) => {
    const target = event.target;
    if (!hasMoreBelts || loadingBelts) return;
    if (target.scrollTop + target.offsetHeight >= target.scrollHeight - 10) {
      await loadBelts(beltPage + 1);
    }
  };

  const handleCancel = () => {
    setVisible(false);
    form.resetFields();
  };

  const handleOk = async (values) => {
    setLoading(true);
    const payload = { ...values };

    if (values.triggersGraduationEligibility) {
      values.requiredClasses = 0;
    }
    callApi({
      callback: addKyu,
      payload,
      onSuccess: ({ message }) => {
        ShowToast(message, Severty.SUCCESS);
        form.resetFields();
        refresh(new Date().getTime());
        setVisible(false);
        setLoading(false);
      },
      onError: (err) => {
        ShowToast(err, Severty.ERROR);
        setLoading(false);
      },
    });
  };

  return (
    <Modal
      open={visible}
      className="tab_modal"
      title="Add Kyu"
      okText="Create"
      onCancel={handleCancel}
      okButtonProps={{
        form: "create",
        htmlType: "submit",
        loading: loading,
      }}
      width={800}
      destroyOnClose
    >
      <Form
        id="create"
        form={form}
        onFinish={handleOk}
        layout="vertical"
        preserve={false}
        initialValues={{
          isActive: true,
          isDeleted: false,
          alwaysEligible: false,
          triggersGraduationEligibility: false,
        }}
      >
        <Form.Item
          name="name"
          label="Kyu Name"
          rules={[{ required: true, message: "Please enter kyu name" }]}
          normalize={val => val?.trimStart()}
        >
          <Input placeholder="e.g., Orange Kyu, Purple Kyu No.1" />
        </Form.Item>

        <Form.Item
          name="description"
          label="Description"
          rules={[{ required: true, message: "Please enter kyu description" }]}
          normalize={val => val?.trimStart()}
        >
          <Input placeholder="Please enter kyu description" />
        </Form.Item>

        <Form.Item
          name="beltId"
          label="Belt"
          rules={[{ required: true, message: "Please select a belt" }]}
        >
          <Select
            placeholder="Select belt"
            loading={loadingBelts}
            onPopupScroll={handleBeltPopupScroll}
          >
            {Array.isArray(belts) &&
              belts.map((belt) => (
                <Select.Option key={belt._id} value={belt._id}>
                  {belt.name}
                </Select.Option>
              ))}
          </Select>
        </Form.Item>

        <Form.Item
          name="requiredClasses"
          label="Classes Required"
          rules={[{ required: false }]}
        >
          <Input type="number" min={0} placeholder="Number of classes needed (or leave blank)"
            disabled={triggersGraduationEligibility} />
        </Form.Item>

        <Form.Item
          name="priorityNumber"
          label="Priority Number"
          rules={
            triggersGraduationEligibility
              ? []
              : [{ required: true, message: "Add Priority Number" }]
          }
        >
          <Input type="number" min={0} placeholder="Number of classes needed (or leave blank)"
            disabled={triggersGraduationEligibility} />
        </Form.Item>

        {/* <Form.Item
          name="requiredKyus"
          label="Prerequisite Kyus"
          rules={[{ required: false }]}
        >
          <Select
            mode="tags"
            style={{ width: "100%" }}
            placeholder="Add Kyu names (exact match)"
            tokenSeparators={[","]}
          />
        </Form.Item> */}

        <Form.Item name="alwaysEligible" valuePropName="checked">
          <Checkbox>Always Eligible</Checkbox>
        </Form.Item>

        <Form.Item name="triggersGraduationEligibility" valuePropName="checked">
          <Checkbox>Triggers Graduation Eligibility (White Kyu)</Checkbox>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default KyuAdd;
